import { inject, Pipe, PipeTransform } from '@angular/core';
import { LightUserRepresentation } from "@alfresco/js-api";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: 'bokuFullName'
})
export class BokuFullNamePipe implements PipeTransform {

  readonly translateService = inject(TranslateService);

  transform(user: LightUserRepresentation, highlight?: string): string {
    if(!user) {
      return "";
    }
    let fullName = `${user.lastName?.toUpperCase()} ${user.firstName}`;
    if(highlight) {
      const regex = new RegExp(`(${highlight})`, 'ig');
      fullName = `${fullName.replace(regex,`<span class="boku-highlight">$1</span>`)}`;
    }
    if (user.email) {
      return `${fullName} &lt;${user.email}&gt;`.trim();
    } else {
      return `${fullName} - <i>${this.translateService.instant("FILTER.INACTIVE_USER")}</i>`;
    }
  }
}
